import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class ListCommonParam {
  page = 1;
  pageSize = 10;
}

export class ExportListParams extends ListCommonParam {
  companyId = 0;
  exportIdList: number[] = [];
}

export class DelExportExcelParam {
  companyId = 0;
  userId = 0;
  exportId = 0;
}

export class MsgRequestParams extends ListCommonParam {
  companyId = 0;
  candidateIdList: number[] = [];
  mobileSendStatusList: number[] = [];
  callSendStatusList: number[] = [];
  emailSendStatusList: number[] = [];
  createTime: string[] = [];
}

export default class MsgRequest extends Model {
  static getMessageLogList(msgRequestParams: MsgRequestParams) {
    return request
      .post("/aiExam/company/messageLogList", msgRequestParams)
      .then(resp => {
        return resp.data;
      });
  }

  static getExportList(exportListParams: ExportListParams) {
    return request
      .post("/aiExam/company/exportExcelList", exportListParams)
      .then(resp => {
        return resp.data;
      });
  }

  static delExportExcel(delExportExcelParam: DelExportExcelParam) {
    return request
      .post("/aiExam/company/exportExcelDelete", delExportExcelParam)
      .then(resp => {
        return resp.data;
      });
  }

  static getCompanyInfo(companyId: number) {
    return request
      .post("/aiExam/company/get", { companyId: companyId })
      .then(resp => {
        return resp.data;
      });
  }
}
export class LogParam extends Model {
  companyId = 0;
  examType = ""; // 面试类型筛选
  examId = 0; // 面试筛选
  mobileSendStatusList: number[] = []; // 短信状态筛选
  emailSendStatusList: number[] = []; // 邮件状态筛选
  env = 0; // 通知场景筛选
  showNameOrPhoneOrEmail = "";
  searchKeyLike = "";
  pageSize = 10;
  page = 1;
}
export class SendParam extends Model {
  companyId = 0;
  logId = 0; // 发送记录id
  sendMobile = false; // 是否发送短信
  sendEmail = false; // 是否发送邮件
  logIdList: number[] = []; //群发id
}
export class Log extends Model {
  public static getList(p: LogParam) {
    return request.post("/aiExam/message/logList", p).then(resp => {
      return resp.data;
    });
  }
  public static sendAsk(params: SendParam) {
    return request.post("aiExam/message/logSend", params).then(resp => {
      return resp.data;
    });
  }
  public static sendAskMulti(params: SendParam) {
    return request.post("aiExam/message/logMSend", params).then(resp => {
      return resp.data;
    });
  }
  public static getAllId(p: LogParam) {
    return request.post("aiExam/message/logListIds", p).then(resp => {
      return resp.data;
    });
  }
}
